/* eslint-disable */
// import { validation } from './commonValidation';

const login = () => {
  const loginForm = document.querySelector('.js-login-form');
  const emailInput = document.querySelector('.js-login-form-email');
  const pwdInput = document.querySelector('.js-login-form-pwd');
  const rememberMeInput = document.querySelector('.js-login-form-remember-me');

  const validateEmail = () => {
    const validateEmailLabel = document.querySelector('.js-validated-email-label');
    const validateEmailInput = document.querySelector('.js-validated-email-input');
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!re.test(validateEmailInput.value.toLowerCase())) {
      validateEmailLabel.classList.add('has-error');
      return false;
    } else {
      validateEmailLabel.classList.remove('has-error');
      return true;
    }
  };

  const loginFieldsValidation = e => {
    e.preventDefault();
    if (validateEmail()) {
      sendLoginForm(e);
    }
  };

  const sendLoginForm = e => {
    e.preventDefault();

    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    let ajaxData = {
      action: 'ks_login_user',
      ks_login_email: emailInput.value,
      ks_login_password: pwdInput.value,
      ks_remember_me: rememberMeInput.checked,
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);

    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );

    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        const result = JSON.parse(this.response);
        if (result.login_error) {
          let error_notify_container = document.querySelector(
            '.js-login-form-error-container',
          );
          let error_notify = document.querySelector(
            '.js-login-form-error-text',
          );
          error_notify.innerHTML = result.login_error;
          error_notify_container.classList.remove('u-hidden');
        }
        if (result.redirection) {
          window.location = result.redirection;
        }
      }
    };

    request.onerror = function() {};

    request.send(ajaxParameters);
  };

  if (loginForm) {
    loginForm.addEventListener('submit', loginFieldsValidation);
    emailInput.addEventListener('keyup', validateEmail);
  }
};

export default login;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/login.js